import { useTheme } from '@flik/shared';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentProps } from '../types';

const COUNTDOWN_SECONDS = 5;

const NotFoundContent: React.FC<ContentProps> = () => {
  const navigate = useNavigate();
  const { provideTailwind } = useTheme();
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Separate effect to handle navigation when countdown reaches 0
  useEffect(() => {
    if (countdown <= 0) {
      navigate('/');
    }
  }, [countdown, navigate]);

  return (
    <div className="p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="mb-8">
          <div className="relative w-20 h-20 mx-auto mb-8">
            {/* Outer pulsing ring */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-br from-pink-500 to-purple-600 animate-pulse opacity-75"></div>

            {/* Main gradient circle */}
            <div className="absolute inset-1 rounded-full bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center">
              {/* Inner spinning ring */}
              <div className="w-10 h-10 border-2 border-white rounded-full border-t-transparent animate-spin"></div>
            </div>
          </div>

          <p
            className={`text-base mb-8 leading-relaxed ${provideTailwind(
              'text-secondary',
            )}`}
          >
            This page doesn't exist. You'll be redirected to the home page in{' '}
            <span className="font-semibold text-pink-500">{countdown}</span>{' '}
            seconds.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundContent;
